import React, { useState } from "react";
import {
    deleteSummarypromptData,
    deleteSummarylength
} from "../../../services/AdminService";
import ModalComponent from '../../../components/ModalComponent'
import { toast } from "react-toastify";

const DeleteSummaryPrompt = ({ type, show, handleClose, item, fetchSummaryData }) => {
    const [loading, setLoading] = useState(false);

    const handleConfirmDelete = async () => {
        setLoading(true);

        try {
            await (type === "document"
                ? deleteSummarypromptData(item.id)
                : deleteSummarylength(item.id));

            toast.success("Summary deleted successfully!");
            fetchSummaryData();
            handleClose();
        } catch {
            toast.error("Failed to delete summary.");
        } finally {
            setLoading(false);
        }
    };

    const footerButtons = [
        {
            label: "Cancel",
            variant: "secondary",
            onClick: handleClose
        },
        {
            label: loading ? "Deleting..." : "Delete",
            variant: "primary",
            onClick: handleConfirmDelete,
            disabled: loading
        }
    ];

    return (
        <ModalComponent
            show={show}
            handleClose={handleClose}
            title="Delete Prompt"
            footerButtons={footerButtons}
            size="sm"
        >
            <p>Are you sure you want to delete?</p>

            <strong>
                {type === "document" ? item?.document_type : item?.length_type}
            </strong>
        </ModalComponent>
    );
};

export default DeleteSummaryPrompt;
